import { render, staticRenderFns } from "./CheckInstitution.vue?vue&type=template&id=8e343b90"
import script from "./CheckInstitution.vue?vue&type=script&lang=js"
export * from "./CheckInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports